export const IMG_LOC = 'assets/images/';

// Tab Containers
export const AOR_VIEW_CONTAINER = 'AorViewComponent';
export const MAIN_CONTAINER = 'MainContainerComponent';
export const MONLOG_SEARCH_CONTAINER = 'MonlogsSearchContainerComponent';
export const MONLOG_DETAILS_CONTAINER = 'MonlogsDetailContainerComponent';
export const MONLOG_PRINT_CONTAINER = 'MonLogPrintContainerComponent';
export const OPALERTLOG_PRINT_CONTAINER = 'OpAlertLogPrintContainerComponent';
export const ALL_MONLOG_SEARCH_CONTAINER =
  'MonlogsAllLogsSearchContainerComponent';
export const OPLOG_DETAILS_CONTAINER = 'OplogsDetailContainerComponent';
export const ALL_OPLOG_SEARCH_CONTAINER =
  'OplogsAllLogsSearchContainerComponent';
export const MC_ST_SEARCH_CONTAINER = 'McShiftTurnoverContainerComponent';
export const MC_ST_DETAIL_CONTAINER = 'McShiftTurnoverDetailComponent';
export const MC_ST_PRINT_CONTAINER = 'McShiftTurnoverPrintContainerComponent';
export const FACILITY_SEARCH_CONTAINER = 'FacilityContainerComponent';
export const FACILITY_DETAIL_CONTAINER = 'FacilityDetailsContainerComponent';
export const LOCATION_CONTAINER = 'LocationContainerComponent';
export const GIS_MAP_EMBED = 'GisMapComponent';
export const FIELD_VISION = 'FieldVisionEmbedComponent';
export const MY_PROFILE_CONTAINER = 'ContactProfileContainerComponent';
export const CONTACT_SEARCH_CONTAINER = 'ContactsSearchContainerComponent';
export const CONTACT_DETAIL_CONTAINER = 'ContactDetailsContainerComponent';
export const CONTACT_LIST_SEARCH_CONTAINER =
  'ContactListSearchContainerComponent';
export const CONTACT_LIST_DETAIL_CONTAINER =
  'ContactListDetailViewContainerComponent';
export const CREATE_CONTACT_LIST_CONTAINER =
  'ContactListCreateContainerComponent';
export const EXTERNAL_LIST_SEARCH_CONTAINER =
  'ExternalContactListSearchContainerComponent';
export const EXTERNAL_LIST_DETAIL_CONTAINER =
  'ExternalContactListDetailsContainerComponent';
export const CONTROLLER_NOTES = 'ControllerNotesContainerComponent';
export const DAILY_OPERATING_PLANS = 'DailyOperatingPlansContainerComponent';
export const CRM_ST_SEARCH_CONTAINER = 'CrmShiftTurnoverContainerComponent';
export const CRM_ST_DETAIL_CONTAINER =
  'CrmShiftTurnoverDetailsContainerComponent';
export const CRM_ST_PRINT_CONTAINER = 'CrmShiftTurnoverPrintContainerComponent';
export const EMAIL_CONTAINER = 'EmailGroupContainerComponent';
export const MON_LOG_TYPES_CONTAINER = 'MonLogTypesContainerComponent';
export const JOB_ROLES_CONTAINER = 'JobRolesContainerComponent';
export const COMPANY_CONTAINER = 'CompanyContainerComponent';
export const MOC_EVENT_SEARCH_CONTAINER = 'MocEventSearchContainerComponent';
export const MOC_EVENT_DETAILS_CONTAINER = 'MocEventDetailsContainerComponent';
export const MOC_EVENT_CATEGORIES_CONTAINER =
  'MocEventCategoryContainerComponent';
export const NOTE_TYPES_CONTAINER = 'NoteTypesContainerComponent';
export const ROLE_CLAIM_ASSIGN_CONTAINER = 'RoleClaimAssignContainerComponent';
export const CLAIM_ROLE_ASSIGN_CONTAINER = 'ClaimRoleAssignContainerComponent';
export const ROLE_BUSINESS_UNIT_ASSIGN_CONTAINER =
  'RoleBusinessUnitAssignContainerComponent';
export const AREAS_CONTAINER = 'AreaContainerComponent';
export const AREA_DETAIL_CONTAINER = 'AreaDetailsContainerComponent';
export const REGIONS_CONTAINER = 'RegionContainerComponent';
export const REGION_DETAIL_CONTAINER = 'RegionDetailsContainerComponent';
export const ALARM_LIMITS_SEARCH_CONTAINER =
  'AlarmLimitsSearchContainerComponent';
export const ALARM_LIMITS_DETAIL_CONTAINER =
  'AlarmLimitsDetailContainerComponent';
export const SYNC_ALARM_LIMITS_CONTAINER = 'SyncAlarmLimitsContainerComponent';
export const SAP_OUTAGE_REPORT_CONTAINER = 'SapOutageReportComponent';
export const READ_ONLY_SAP_VIEW = 'ReadOnlySapViewComponent';
export const STATION_LOGS_CONTAINER = 'StationLogsSearchContainerComponent';
export const PARTS_SEARCH_CONTAINER = 'PartsSearchContainerComponent';
export const TROUBLESHOOTING_SEARCH_CONTAINER =
  'TroubleshootingSearchContainerComponent';
export const MOBILE_MONLOG_SEARCH_CONTAINER = 'McLogSearchComponent';
export const MOBILE_MONLOG_DETAILS_CONTAINER = 'McLogDetailsComponent';
export const MUSTER_LIST_SEARCH_CONTAINER =
  'MusterListSearchContainerComponent';
export const NOTE_FORM_CONTAINER = 'NoteFormComponent';
export const MOBILE_CONTROLLER_NOTES_SEARCH_CONTAINER =
  'MobileControllerNotesSearch';
export const MOBILE_NOTE_FORM = 'MobileNoteForm';
export const FACILITY_VISITORS_LOG = 'FacilityVisitorLogComponent';
export const COMMERCIAL_CONTACT_SEARCH_CONTAINER =
  'CommercialContactsSearchContainerComponent';
export const COMMERCIAL_CONTACT_DETAIL_CONTAINER =
  'CommercialContactDetailsContainerComponent';
export const COMMERCIAL_FACILITY_SEARCH_CONTAINER =
  'CommercialFacilitiesSearchContainerComponent';
export const COMMERCIAL_FACILITY_DETAIL_CONTAINER =
  'CommercialFacilityDetailsContainerComponent';
export const COMMERCIAL_OUTAGE_SEARCH_CONTAINER =
  'CommercialOutagesSearchContainerComponent';
export const COMMERCIAL_OUTAGE_DETAIL_CONTAINER =
  'CommercialOutageDetailContainerComponent';
